var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClipboard = function SvgClipboard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h4.175q.275-.875 1.075-1.437A2.98 2.98 0 0 1 12 1a3 3 0 0 1 1.787.563q.788.563 1.063 1.437H19q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-2h14V5h-2v2q0 .424-.288.713A.97.97 0 0 1 16 8H8a.97.97 0 0 1-.713-.287A.97.97 0 0 1 7 7V5H5zm7-14q.424 0 .713-.287A.97.97 0 0 0 13 4a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 3a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 4q0 .424.287.713Q11.576 5 12 5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClipboard);
export { ForwardRef as ReactComponent };